import{useEffect as o}from"react";import{useRouter as n}from"next/router";var d=(r={})=>{let a=n();o(()=>{let t=document.querySelector("head"),e=document.createElement("script");return e.type="text/javascript",e.async=!0,e.id="google-analytics",e.innerHTML=`
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(${JSON.stringify(r)});
        `,t?.appendChild(e),()=>{t?.removeChild(e)}},[a])};export{d as a};
